import { IMask } from 'react-imask';

// Amounts are kronor with öre decimals, which binary floats cannot all hold exactly: 100,10 +
// 200,20 + 300,30 adds up to 600.5999999999999. So money is added up in whole öre, which is exact,
// and divided back once.
export const toOre = (kronor: number) => Math.round(kronor * 100)
export const sumKronor = (amounts: number[]) => amounts.reduce((sum, amount) => sum + toOre(amount), 0) / 100

const pipe = IMask.createPipe(
  {
      mask: Number,
      thousandsSeparator: ' ',
      padFractionalZeros: true
  },
  IMask.PIPE_TYPE.TYPED,
  IMask.PIPE_TYPE.MASKED
);

// Rounded to the öre first: IMask cuts the decimals beyond the second rather than rounding them,
// so a float a hair below the true amount would show one öre short (600,59 for 600,60).
const formatCurrency = (kronor: number) => pipe(toOre(kronor) / 100)

export default formatCurrency
